export const GP1SUBSCRIBERSSEGMENT = "gp_1_subscribers_1_3_month"
export const GP1SUBSCRIBERSSEGMENTFREEGIFT =
  "gp_1_subscribers_1_3_month_free_gift"
export const FATHERSDAYRETENTIONPAIDADSAUDIENCE2024 =
  "2024_fathers_day_retention_paid_ads_audience"
export const GP1MONTHLYSUBSSEGMENT = "gp_1_monthly_subs"
export const GP1MONTHLYSUBSGREEGIFT = "gp_1_monthly_subs_free_gift"
export const GP1MONTHLYSUBSFREEGIFTOCT = "gp_1_monthly_subs_free_gift_october"
export const BFCM2024SEGMENT = "gp_1_subscribers_1_3_month"

export const JUNEMASTERGIFTSEGMENT = "june_25_upgrade_womens_gwp"
export const JUNEMENGIFTSEGMENT = "june_25_upgrade_mens_gwp"
export const JUNEMASTERGIFTSEGMENTACCEPTED =
  "june_25_upgrade_womens_gwp_accepted"
export const JUNEMENGIFTSEGMENTACCEPTED = "june_25_upgrade_mens_gwp_accepted"

// July Account Upgrade Segments
export const JULY25MASTERGIFTSEGMENT = "july_25_upgrade_womens_25"
export const JULY30MASTERGIFTSEGMENT = "july_25_upgrade_womens_30"
export const JULY25MENGIFTSEGMENT = "july_25_upgrade_mens_25"
export const JULY30MENGIFTSEGMENT = "july_25_upgrade_mens_30"

export const JULY25MASTERGIFTSEGMENTACCEPTED =
  "july_25_upgrade_womens_25_accepted"
export const JULY30MASTERGIFTSEGMENTACCEPTED =
  "july_25_upgrade_womens_30_accepted"
export const JULY25MENGIFTSEGMENTACCEPTED = "july_25_upgrade_mens_25_accepted"
export const JULY30MENGIFTSEGMENTACCEPTED = "july_25_upgrade_mens_30_accepted"
